"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var error_exports = {};
__export(error_exports, {
  HulylakeError: () => HulylakeError,
  NetworkError: () => NetworkError
});
module.exports = __toCommonJS(error_exports);
class NetworkError extends Error {
  static {
    __name(this, "NetworkError");
  }
  constructor(message) {
    super(message);
    this.name = "NetworkError";
  }
}
class HulylakeError extends Error {
  static {
    __name(this, "HulylakeError");
  }
  constructor(message) {
    super(message);
    this.name = "HulylakeError";
  }
}
//# sourceMappingURL=error.js.map
